import http from '@/http'
import { Part } from '@/interfaces/library'

export async function getPart (id: Number): Promise<Part> {
  const { data } = await http.get(`/parts/${id}`)
  return data
}